import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { getFileUrl, revokeFileUrl } from '../lib/s3';

const Products = ({ featuredProducts }) => {
  const validProducts = (featuredProducts || []).filter(
    (product) => product && String(product.product_name || '').trim() !== ''
  );

  if (validProducts.length === 0) return null;

  return (
    <div className="px-5 mt-8">
      <p className="text-black font-semibold text-lg">Featured</p>
      <div className="mt-3 flex flex-col gap-5">
        {validProducts.map((product, index) => {
          const link = String(product.product_link || '').trim();
          const href = link ? (link.startsWith('http') ? link : `https://${link}`) : null;

          const content = (
            <span className="rounded-md bg-black flex items-center gap-3 px-2 cursor-pointer py-2 text-white">
              <span className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center">
                <ProductImage image={product.product_image} name={product.product_name} />
              </span>
              <p className="text-white text-sm sm:text-base">{product.product_name}</p>
            </span>
          );

          return href ? (
            <a href={href} key={product.id ?? index} target="_blank" rel="noopener noreferrer">
              {content}
            </a>
          ) : (
            <div key={product.id ?? index}>{content}</div>
          );
        })}
      </div>
    </div>
  )
}

const ProductImage = ({ image, name }) => {
  const [imageError, setImageError] = useState(false);
  const [src, setSrc] = useState('');

  useEffect(() => {
    let cancelled = false;
    let blobUrl = '';

    const load = async () => {
      if (!image) return;
      const key = image.includes('/') ? image : `products/${image}`;
      const url = await getFileUrl(key);
      if (cancelled) {
        revokeFileUrl(url);
        return;
      }
      revokeFileUrl(blobUrl);
      blobUrl = url || '';
      if (url) setSrc(url);
    };

    load();
    return () => {
      cancelled = true;
      revokeFileUrl(blobUrl);
    };
  }, [image]);

  if (imageError || !src) {
    return <FontAwesomeIcon icon={faImage} className="w-full h-full text-white" />;
  }

  return (
    <img
      src={src}
      alt={name}
      className="w-full h-full object-cover rounded-md"
      onError={() => setImageError(true)}
    />
  );
};

export default Products